/**
 * TODO: move all hook functions into store/apis/buildings/buildings.hook.ts
 */

import { useMemo } from 'react';

import { IBuilding, IBuildingItem } from 'models';
import { useFetchBuildingQuery, useFetchBuildingsQuery } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';
import { filterBuildingItems, getBuildingImageUrl, getBuildingLocation } from 'utils';
import { useZones } from 'pages/zones/zones.hook';

export const useBuildings = (): [boolean, IBuilding[]] => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data: buildings, isLoading } = useFetchBuildingsQuery({ orgSlug });

  return useMemo(() => {
    return [isLoading, buildings || []];
  }, [isLoading, buildings]);
};

type UseBuildingItemsProps = {
  searchKeyword: string;
};

export const useBuildingItems = ({ searchKeyword }: UseBuildingItemsProps): [boolean, IBuildingItem[]] => {
  const [loadingBuildings, buildings] = useBuildings();
  const [loadingZones, { active: activeZones }] = useZones({ buildingId: null });

  let buildingItems = (buildings || []).map((building) => {
    const { id, created_at } = building;
    const thumbnail = getBuildingImageUrl(building);
    const location = getBuildingLocation(building);
    const floors = building.floors.length;
    const zones = activeZones.filter((zone) => zone.building_id === building.id).length;

    return {
      id,
      thumbnail,
      location,
      floors,
      zones,
      created_at,
    } as IBuildingItem;
  });

  if (searchKeyword) {
    buildingItems = filterBuildingItems(buildingItems, searchKeyword);
  }

  return useMemo(() => {
    return [loadingBuildings || loadingZones, buildingItems];
  }, [loadingBuildings, loadingZones, buildingItems]);
};

export type UseBuildingProps = {
  buildingId: number;
};

export const useBuilding = ({ buildingId }: UseBuildingProps): [boolean, IBuilding] => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data, isLoading } = useFetchBuildingQuery({ orgSlug, id: buildingId });

  return useMemo(() => [isLoading, data], [isLoading, data]);
};
